module.exports = __webpack_public_path__ + "img/21.5ab3f84c.jpg";